import type { User } from 'firebase/auth';

type Sync = (user: User) => void;

let sync: Sync | null = null;

/** useAuth registers the profile load. Sign-in calls it after a Google popup. */
export function registerAuthSessionSync(next: Sync) {
  sync = next;
  return () => {
    if (sync === next) sync = null;
  };
}

export function requestAuthSessionSync(user: User) {
  sync?.(user);
}
